import { FORGOT_PASSWORD, ERROR } from './actionsTypes';
import { sendResponse } from './request';
import { startRequest, endRequest } from './loading';
import axios from 'axios';

const apiUrl = `${window.$urlService}/forgot`;

export const forgot = (item) => {
  return (dispatch) => {
    dispatch(startRequest())
    return axios.post(`${apiUrl}/`, item)
      .then(response => {
        dispatch(forgotSuccess(response.data))
        dispatch(sendResponse(response.status, 'Forgot Password successfully!'))
        dispatch(endRequest())
      })
      .catch(error => {
        dispatch(errorResponse('Error on Forgot Password', error, dispatch))
        throw(error);
      });
  };
};

/**
 * Thrown an error message to components
 * @param {*} message 
 * @param {*} error 
 * @param {*} dispatch 
 */
export const errorResponse = (message, error, dispatch) => {
  dispatch(sendResponse(500, message +': "'+ error + '"'))
  dispatch(endRequest())
  return { type: ERROR, payload: [] }
};

/**
 * 
 * @param {*} data 
 */
export const forgotSuccess = (data) => {
  return {
    type: FORGOT_PASSWORD,
    payload: data
  }
};



// WEBPACK FOOTER //
// ./src/actions/forgot.js